module.exports = __webpack_public_path__ + "static/media/404_images.5b94d303.jpg";